import { render, staticRenderFns } from "./icon-envelope.vue?vue&type=template&id=b1b6c6d2&"
import script from "./icon-envelope.vue?vue&type=script&lang=js&"
export * from "./icon-envelope.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Volumes/Third Coast Creative/repos/MidwestBeltone.Iframes/MidwestBeltone.Iframes.Web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b1b6c6d2')) {
      api.createRecord('b1b6c6d2', component.options)
    } else {
      api.reload('b1b6c6d2', component.options)
    }
    module.hot.accept("./icon-envelope.vue?vue&type=template&id=b1b6c6d2&", function () {
      api.rerender('b1b6c6d2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "Frontend/vue/icons/icon-envelope.vue"
export default component.exports